<template>
	<div class="index">
		<div class="list" >
			<template v-for="(item, index) in GGcate">
				<div class="item" :key="index">
					<!-- <div class="d1">
						<img class="img1" src="../../assets/images/dian.png" />
						{{ item.cate_name }}
					</div> -->
					<div v-if="item.original_id && item.page_path" style="position: relative;width:100%;margin:0 auto;">
						<div v-if="open==1">
							<img :src="item.pic" class="img2 btn" style="width:90%" />
							<div>
								<div class="jds">{{ item.lookcount }}/{{item.count}}</div>
							</div>
						</div>
						<div v-else @click="getDetail(item.special_id,item.id,item.count,item.lookcount)">
							<img :src="item.pic" class="img2 btn" style="width:90%" />
							<div>
								<div class="jds">{{ item.lookcount }}/{{item.count}}</div>
							</div>
						</div>
						<div v-if="open==1">
							<wx-open-launch-weapp id="launch-btn" :username="item.original_id" :path="item.page_path"
								style='position: absolute; top:0'
								@click="getDetail(item.special_id,item.id,item.count,item.lookcount)">
								<script type="text/wxtag-template">
									<div class="d2" style="width:90%;margin:0 auto;height:12rem;">
								<div class="d2"  style="width:100%;margin:0 auto;height:12rem;" ></div>	
							</script>
							</wx-open-launch-weapp>
						</div>
					</div>
					<div v-if="!item.original_id || !item.page_path" class="d2" style="width:90%;margin:0 auto"
						@click="goGGdetail(item.id,item.count,item.lookcount)">
						<img :src="item.pic" class="img2 btn" style="width:100%" />
						<div>
							<div class="jd">{{ item.lookcount }}/{{item.count}}</div>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
	
	import {
		specialList,
		ended,
		getnotseen,
		getCodename
	} from "@api/user";
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "@assets/css/swiper.min.css";
	import {
		imageBase64
	} from "@api/public";
	import {
		getHomeData,
		getShare
	} from "@api/public";
	import cookie from "@utils/store/cookie";
	import {
		openShareAppMessage,
		openShareTimeline,
		wx_getLocation,
		ready
	} from "@libs/wechat";
	import {
		isWeixin
	} from "@utils/index";
	import {
		Popup
	} from 'vant';
let vm = null;
	const HAS_COUPON_WINDOW = "has_coupon_window";
	const MAPKEY = "mapKey";
	export default {
		name: "Index",

		props: {},
		data: function() {
			const {
				spread = 0
			} = this.$route.query;
			return {
				GGcate: [],
				subscribe: false,
				followHid: true,
				followCode: false,
				isWeixin: isWeixin(),
				banner: [],
				newGoodsBananr: "",
				followUrl: "",
				showCoupon: false,
				logoUrl: "",
				menus: [],
				roll: [],
				activity: [],
				activityOne: {},
				info: {
					fastList: [],
					bastBanner: [],
					firstList: [],
					bastList: []
				},
				likeInfo: [],
				lovely: [],
				benefit: [],
				couponList: [],
				swiperOption: {
					pagination: {
						el: ".paginationBanner",
						clickable: true
					},
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true,
				},
				swiperRoll: {
					direction: "vertical",
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperScroll: {
					freeMode: true,
					freeModeMomentum: false,
					slidesPerView: "auto",
					observer: true,
					observeParents: true
				},
				swiperBoutique: {
					pagination: {
						el: ".paginationBoutique",
						clickable: true
					},
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperProducts: {
					freeMode: true,
					freeModeMomentum: false,
					slidesPerView: "auto",
					observer: true,
					observeParents: true
				},
				mapKey: "",
				time: 1,
				space_time: "",
				deltype: true,
				open: 1,
				username: '',
				path: '',
				ids: ''
			};
		},

		watch: {
			GGcate(newVal, oldVal) {
				console.log(newVal)
			},
			immediate: true,
			deep: true
		},
		mounted: function() {
			this.getnewgg();
		},
		created() {
			vm = this;
			this.getCodename()
		},
		methods: {
			btnsmall() {
				var btn = document.getElementById('launch-btn');
				btn.addEventListener('launch', function(e) {
					console.log('success');
				});
				btn.addEventListener('error', function(e) {
					console.log('fail', e.detail);
				});
			},
			async getDetail(id, item, count, lookcount) {
				let that = this;
				that.open = ''
				if (count == "0") {
					that.$dialog.error("活动即将上线！敬请期待");
					return false
				}
				if (count == lookcount) {
					that.$dialog.error("今日观看次数已达上限！");
					return false
				}
				var time = Date.parse(new Date()) / 1000 //获取当前时间戳 10位
				var ltime = localStorage.getItem('mtime'); //获取缓存时间
				var jtime = 1 //后台返货间隔时间
				var nt = new Date();
				var mtime = nt.setTime(parseInt(time))
				var a = 1
				var s = jtime
				if (ltime) {
					// that.$dialog.error("任务失败");
					console.log(11111)
					that.open = ''
					// if (parseInt(time) - parseInt(ltime) < jtime) {
					getnotseen(item, 1, lookcount).then((e) => {}).catch(res => {});
					console.log(2222 )
					return false
					// }
				}
				var run = setInterval(function() {
					a++
					if (a >= s) {
						that.getnewgg(1, item)
						that.open = 1
						localStorage.removeItem('mtime');
						clearInterval(run)
						a = 0
					}
					console.log(a)
				}, 1000)
			
				localStorage.setItem('mtime', mtime);
				that.open = ''
				that.btnsmall()
				getnotseen(item).then((e) => {
					console.log(e.data.nolook.id)
					ended(e.data.nolook.id).then((e) => {});
			
				}).catch(res => {
					localStorage.removeItem('mtime');
					that.$dialog.error(res.msg);
				});
			
			
			},
			async getCodename() {
				console.log(window.location.href.split('#')[0])
				const res = await getCodename({
					sUrl: window.location.href.split('#')[0]
				})
				wx.config({
					debug: false,
					appId: res.data.appId,
					timestamp: res.data.timestamp,
					nonceStr: res.data.nonceStr,
					signature: res.data.signature,
					jsApiList: [
						'wx-open-launch-weapp', // 跳转小程序
						'getLocation', // 获取定位信息
						'openLocation', // 导航
						'onMenuShareAppMessage', // 分享给朋友
						'onMenuShareTimeline', // 分享到朋友圈
						'onMenuShareQQ', // 分享到QQ
						'onMenuShareQZone', // 分享到QQ空间
						'checkJsApi' // 判断当前客户端版本是否支持指定JS接口
					],
					openTagList: ['wx-open-launch-weapp'] //打开的标签名
				})
				wx.ready(function() {
					console.log('config is success')
				})
				wx.error(function(err) {
					console.log(err)
				})
			
			},
			closeFollow() {
				this.followHid = false;
			},
			
			followTap() {
				this.followCode = true;
			},
			// 广告跳转
			goGGdetail(item, count, lookcount) {
				let that = this;
				if (count == "0") {
					that.$dialog.error("活动即将上线！敬请期待");
					return false
				}
				if (count == lookcount) {
					that.$dialog.error("今日观看次数已达上限！");
					return false
				}
				// var time = Date.parse(new Date()) / 1000
				// var ltime = localStorage.getItem('nexttime');
				// var jtime = that.space_time
				// if (ltime) {
				// 	if (parseInt(time) - parseInt(ltime) < jtime) {
				// 		getnotseen(item, 1, lookcount).then((e) => {}).catch(res => {
				// 			that.getnewgg()
				// 			// that.$dialog.error("任务失败");
				// 		});
				// 		return false
				// 	}
				// }
				// var nt = new Date();
				// var nexttime = nt.setTime(parseInt(time))
				// localStorage.setItem('nexttime', nexttime);
				getnotseen(item).then((e) => {
					ended(e.data.nolook.id).then((e) => {}).catch(res => {
						that.$dialog.error(res.msg);
					});
					// 二维码
					if (e.data.nolook) {
						// setTimeout(function() {
							that.getnewgg(1, item)
						// }, jtime * 1000)
						var gg = e.data.nolook
						if (gg.special_url) {
							window.location.href = gg.special_url
						}else if (gg.special_image) {
							that.$router.push({
								path: "/gtdetail?url=" + gg.special_image + "&adid=" + gg.id
							});
						} else if (gg.special_url) {
							that.$router.push({
								path: "/ggdetail?url=" + gg.special_url + "&adid=" + gg.id
							});
						}
							
					} else {
			
					}
				}).catch(res => {
					// localStorage.removeItem('nexttime');
					that.$dialog.error(res.msg);
				});
			},
			getnewgg(user_type = "", cate_id = ""){
				let that = this;
				specialList({
					user_type, cate_id
				}).then(res => {
					that.mapKey = res.data.tengxun_map_key;
					cookie.set(MAPKEY, that.mapKey);
					that.logoUrl = res.data.logoUrl;
					that.GGcate = res.data.ad;
					that.newGoodsBananr = res.data.newGoodsBananr;
					that.$set(that, "banner", res.data.banner);
					that.$set(that, "menus", res.data.menus);
					that.$set(that, "roll", res.data.roll);
					that.$set(that, "activity", res.data.activity);
					if (res.data.activity.length) {
						var activityOne = res.data.activity.shift();
						that.$set(that, "activityOne", activityOne);
					}
					that.$set(that, "info", res.data.info);
					that.$set(that, "likeInfo", res.data.likeInfo);
					that.$set(
						that,
						"lovely",
						res.data.lovely.length ? res.data.lovely[0] : {}
					);
					that.$set(that, "benefit", res.data.benefit);
					that.$set(that, "couponList", res.data.couponList);
					that.subscribe = res.data.subscribe;
					that.space_time = res.data.space_time;
					
					// if (!that.subscribe && that.followUrl) {
					// 	setTimeout(function() {
					// 		that.followHid = true;
					// 	}, 200);
					// } else {
					// 	that.followHid = false;
					// }
					if (res.data.site_name) document.title = res.data.site_name;
					// that.setOpenShare();
					this.showCoupon = !cookie.has(HAS_COUPON_WINDOW) &&
						res.data.couponList.some(coupon => coupon.is_use);
					// if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
				});
			}
			
		}
	};
</script>
<style scoped>
	.a {
		width: 4.5rem !important;
		margin-right: 0.28rem !important;
		padding-right: 0 !important;
	}

	.shareda {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 999;
	}

	.bottomShare {
		width: 100%;
		height: 100px;
		background-color: #FFFFFF;
		position: fixed;
		bottom: 50px;
		display: flex;
		align-items: center;
	}

	.bottomShare1 {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.index {
		background-color: #fff;
	}

	.stores-box .stores-block-box {
		width: 100%;
		padding: 10px;
		margin-bottom: 10px;
		background: white;
		display: flex;
		justify-content: space-between;
	}

	.stores-box .stores-block-box .stores-one {
		width: 27%;
	}

	.stores-box .stores-block-box .stores-two {
		width: 70%;
	}

	.stores-box .stores-block-box .stores-two p:nth-of-type(2) img {
		width: 17px;
	}

	.stores-box .stores-block-box .stores-two .stores-add-box p {
		float: left;
	}

	.stores-block-box img {
		width: 100%;
		border-radius: 8%;
	}

	.stores-two p {
		line-height: 25px;
	}

	.change_city {
		position: fixed;
		z-index: 99;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.change_city .mask {
		background: none;
	}

	.change_city .body {
		width: 300px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: #fff;
		padding: 15px;
		border-radius: 10px;
		box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
		z-index: 99;
	}

	.change_city .body .title {
		font-size: 16px;
		margin-bottom: 10px;
	}

	.change_city .body .list {
		min-height: 84px;
	}

	.change_city .body .list .item {
		padding: 3px 0;
		display: inline-block;
		width: 20%;
		margin-right: 5%;
		text-align: center;
		margin-top: 5px;
		border: 1px solid #FFFFFF;
		border-radius: 5px;
	}

	.change_city .body .list .item.active {
		color: #FF0000;
		border: 1px solid #FF0000;
	}

	.adver {
		height: auto !important;
	}

	#launch-btn {
		display: block;
		width: 100%;
		height: 4.6rem;
	}

	[v-cloak] {
		display: none;
	}

	.index {
		background-color: #fff;
		padding: 0.2rem;
		padding-top: 0.5rem;
	}

	.header1 {
		position: relative;
		width: 100%;
		margin-bottom: 0.5rem;
		/* padding-bottom: 0.5rem; */
	}

	.header1 .bg {
		width: 100%;
		height: 3rem;
	}

	.header1 .title {
		position: absolute;
		width: 100%;
		text-align: center;
		top: 0.1rem;
		font-size: 0.35rem;
		color: #ffffff;
	}

	.header1 .swiper1 {
		position: absolute;
		top: 0.2rem !important;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		width: 100%;
		height: 3.5rem;
	}

	.header1 .swiper1 div {
		width: 100%;
		height: 100%;

	}

	.tag-read {
		color: orange;
	}

	.header1 .swiper1 img {
		width: 100%;
		height: 100%;
		border-radius: 0.2rem;
	}

	.midd {
		position: relative;
		width: 100%;
	}

	.img1 {
		position: relative;
		/* left: 0.625rem; */
		width: 0.2rem;
		height: 0.2rem;
	}

	.d2 {
		position: relative;

	}

	.d1 {
		padding-left: 0.3rem;
		margin-bottom: 0.15rem;
		margin-top: 0.15rem;
	}

	.img2 {
		/* position: absolute; */
		width: 5rem;
		height: 4.2rem;
		margin: 0 auto;
		display: block;
		border-radius: 0.2rem;
	}

	.jd {
		font-size: 0.35rem;
		position: absolute;
		right: 3%;
		top: 7%;
		background-color: rgba(100, 100, 100, 0.5);
		width: 1rem;
		height: 0.4rem;
		line-height: 0.4rem;
		border-radius: 0.2rem;
		text-align: center;
		color: #fff;
	}

	.jds {
		font-size: 0.35rem;
		position: absolute;
		right: 7%;
		top: 7%;
		background-color: rgba(100, 100, 100, 0.5);
		width: 1rem;
		height: 0.4rem;
		line-height: 0.4rem;
		border-radius: 0.2rem;
		text-align: center;
		color: #fff;
	}

	.shoucang {
		position: absolute;
		right: 1.6rem;
		top: 0.625rem;
		width: 0.35rem;
		height: 0.35rem;
	}

/*首页*/
.index .follow{position:fixed;top:0;left:0;width:100%;background-color:rgba(0,0,0,0.36);height:0.8rem;font-size:0.28rem;color:#fff;padding: 0 0.3rem;}
.index .follow .bnt{width:1.6rem;height:0.5rem;background-color:#E93323;border-radius:0.25rem;font-size:0.24rem;text-align:center;line-height:0.5rem;}
.index .follow .iconfont{font-size:0.3rem;margin-left:0.29rem;}
.index .followCode .pictrue{width:5rem;height:7.2rem;border-radius:12px;left:50%;top:50%;margin-left:-2.5rem;margin-top:-3.6rem;position:fixed;z-index:666;}
.index .followCode .pictrue img{width:100%;height:100%;}
.index .header{height:0.98rem;width:100%;}
.index .header .logo{width:1.27rem;height:0.45rem;margin-right:0.25rem;}
.index .header .logo img{width:100%;height:100%;display:block;}
.index .header .search{width:5rem;height:0.64rem;background-color:#f7f7f7;border-radius:0.5rem;padding:0 0.28rem;
    font-size:0.28rem;color:#bbb;}
.index .header  .search .iconfont{font-size:0.34rem;margin-right:0.16rem;}
.index .banner{height:3.75rem;}
.index .banner img{width:100%;height:100%;}
.index .banner .swiper-pagination{bottom:0.07rem;}
.index .banner .swiper-pagination-bullet{width:0.2rem;height:0.04rem;border-radius:0.03rem;
    background-color:#fff;opacity:0.6;}
.index .banner .swiper-pagination-bullet-active{opacity:1;}
.index .nav{padding-top:0.26rem;}
.index .nav .item{width:25%;text-align:center;font-size:0.26rem;margin-bottom:0.35rem;}
.index .nav .item .pictrue{width:0.9rem;height:0.9rem;margin:0 auto 0.15rem auto;}
.index .nav .item .pictrue img{width:100%;height:100%;border-radius:50%;}
.index .news{height:0.77rem;border-top:1px solid #f4f4f4;padding:0 0.3rem;box-shadow:0 0.1rem 0.3rem #f5f5f5;
-webkit-box-shadow:0 0.1rem 0.3rem #f5f5f5;-moz-box-shadow:0 0.1rem 0.3rem #f5f5f5;-o-box-shadow:0 0.1rem 0.3rem #f5f5f5;}
.index .news .pictrue{width:1.24rem;height:0.28rem;border-right:1px solid #ddd;padding-right:0.23rem;box-sizing:content-box;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;}
.index .news .pictrue img{width:100%;height:100%;display:block;}
.index .news .new-banner{width:5.23rem;overflow:hidden;height:0.77rem;}
.index .news .new-banner .swiper-slide{height:100%;}
.index .news .new-banner .text{width:4.8rem;height:0.77rem;}
.index .news .new-banner .text .label{font-size:0.2rem;color:#ff4c48;width:0.68rem;height:0.34rem;border-radius:0.2rem;
    text-align:center;line-height:0.34rem;border:0.02rem solid #ff4947;}
.index .news .new-banner .text .newsTitle{width:3.97rem;font-size:0.24rem;color:#666;}
.index .news .new-banner .iconfont{font-size:0.28rem;color:#888;}
.index .specialArea{padding:0.3rem;}
.index .specialArea .assemble{width:2.6rem;height:2.6rem;position:relative;}
.index .specialArea .assemble img{width:100%;height:100%;border-radius:0.05rem;}
.index .specialArea .assemble .text{position:absolute;top:0.37rem;left:0.22rem;}
.index .specialArea .name{font-size:0.3rem;color:#fff;}
.index .specialArea .infor{font-size:0.22rem;color:rgba(255, 255, 255, 0.8);margin-top:0.05rem;}
.index .specialArea .list{height:2.6rem;width:4.16rem;}
.index .specialArea .item{width:100%;height:1.24rem;position:relative;}
.index .specialArea .item img{width:100%;height:100%;}
.index .specialArea .item .text{position:absolute;top:0.23rem;left:0.28rem;}
.index .wrapper .title{border-top:1px solid #eee;padding-top:0.34rem;margin:0 0.3rem;}
.index .wrapper .title .text{font-size:0.24rem;color:#999;width:5.3rem;text-align: left;}
.index .wrapper .title .text .name{color:#282828;font-size:0.3rem;font-weight:bold;margin-bottom:0.05rem;position:relative;}
.index .wrapper .title .text .name .new{position:absolute;top:0.02rem;left:1.3rem;font-size:0.16rem;font-weight:bold;}
.index .wrapper .title .more{font-size:0.26rem;color:#333;}
.index .wrapper .title .more .iconfont{margin-left:0.02rem;font-size:0.26rem;}
.index .wrapper .scroll-product{white-space:nowrap;margin-top:0.38rem;padding:0 0.3rem 0.37rem 0.3rem;overflow:hidden;}
.index .wrapper .scroll-product .swiper-slide{width:1.8rem;display:inline-block;margin-right:0.19rem;
    border-bottom:0.04rem solid #47b479;box-shadow:0 0.15rem 0.15rem -0.1rem #eee;
    -webkit-box-shadow:0 0.15rem 0.15rem -0.1rem #eee;-moz-box-shadow:0 0.15rem 0.15rem -0.1rem #eee;-o-box-shadow:0 0.15rem 0.15rem -0.1rem #eee;}
.index .wrapper .scroll-product .swiper-slide:nth-of-type(3n){border-bottom:0.04rem solid #ff6960;}
.index .wrapper .scroll-product .swiper-slide:nth-of-type(3n-1){border-bottom:0.04rem solid #579afe;}
.index .wrapper .scroll-product .swiper-slide:nth-last-child(1){margin-right:0;}
.index .wrapper .scroll-product .swiper-slide .img-box{width:100%;height:1.8rem;}
.index .wrapper .scroll-product .swiper-slide .img-box img{width:100%;height:100%;border-radius:0.06rem 0.06rem 0 0;}
.index .wrapper .scroll-product .swiper-slide .pro-info{font-size:0.24rem;color:#282828;text-align:center;height:0.6rem;
    line-height:0.6rem;border:1px solid #f5f5f5;border-bottom:0;border-top:0;padding:0 0.1rem;}.index .wrapper .boutique{width:6.9rem;height:2.9rem;margin:0.28rem auto 0 auto;}
.index .wrapper .boutique{width:6.9rem;height:2.9rem;margin:0.28rem auto 0 auto;}
.index .wrapper .boutique img{width:100%;height:2.6rem;}
.index .wrapper .boutique .swiper-pagination{bottom:-0.08rem;width:100%;}
.index .wrapper .boutique .swiper-pagination-bullet{width:0.07rem;height:0.07rem;border-radius:50%;
    background-color:#fc4141;opacity:0.3;}
.index .wrapper .boutique .swiper-pagination-bullet~ .swiper-pagination-bullet{margin-left:0.1rem;}
.index .wrapper .boutique .swiper-pagination-bullet-active{width:0.2rem;height:0.07rem;border-radius:0.035rem;opacity:1}
.index .hotList .hot-bg .title{height:0.87rem;}
.index .hotList .hot-bg .title .text{width:5.75rem;}
.index .hotList .hot-bg .title .text .label{font-size:0.3rem;font-weight:bold;margin-right:0.2rem;}
.index .hotList .hot-bg .title .more{font-size:0.26rem;color:#fff;}
.index .hotList .hot-bg .title .more .iconfont{font-size:0.25rem;vertical-align:0.02rem;margin-left:0.1rem;}
.index .hotList .list{width:6.9rem;height:3.3rem;border-radius:0.2rem;background-color:#fff;margin:-1.28rem auto 0 auto;
    padding:0 0.22rem;box-shadow: 0 0 0.2rem -0.1rem #aaa;-moz-box-shadow:0 0 0.2rem -0.1rem #aaa;
    -webkit-box-shadow:0 0 0.2rem -0.1rem #aaa;-o-box-shadow:0 0 0.2rem -0.1rem #aaa;}
.index .hotList .list .item{width:2rem;text-align: left;}
.index .hotList .list .item~.item{margin-left:0.23rem;}
.index .hotList .list .item .pictrue{width:100%;height:2rem;position:relative;}
.index .hotList .list .item .pictrue img{width:100%;height:100%;border-radius:0.1rem;}
.index .hotList .list .item .pictrue .numPic{width:0.5rem;height:0.5rem;border-radius:50%;position:absolute;top:0.07rem;
    left:0.07rem;}
.index .hotList .list .item .name{font-size:0.26rem;color:#282828;margin-top:0.12rem;}
.index .hotList .list .item .money{font-size:0.2rem;font-weight:bold;margin-top: 0.02rem;}
.index .hotList .list .item .money .num{font-size:0.28rem;}
.index .adver{width:100%;height:1.8rem;margin-top:0.37rem;}
.index .adver img{width:100%;height:100%;display:block;}
.index .wrapper .newProducts{white-space:nowrap;padding:0 0.3rem;margin:0.35rem 0 0.42rem 0;overflow:hidden;}
.index .wrapper .newProducts .swiper-slide{display:inline-block;width:2.43rem;margin-right:0.2rem;border:1px solid #eee;
    border-radius:0.12rem;}
.index .wrapper .newProducts .swiper-slide:nth-last-child(1){margin-right:0;}
.index .wrapper .newProducts .swiper-slide .img-box{width:100%;height:2.4rem;}
.index .wrapper .newProducts .swiper-slide .img-box img{width:100%;height:100%;border-radius:0.12rem 0.12rem 0 0;}
.index .wrapper .newProducts .swiper-slide .pro-info{font-size:0.28rem;color:#333;text-align:center;padding:0.15rem 0.1rem 0 0.1rem;}
.index .wrapper .newProducts .swiper-slide .money{padding:0 0.1rem 0.18rem 0.1rem;text-align:center;font-size:0.26rem;font-weight:bold;}
</style>
